import React from "react";
import {Form} from 'react-bootstrap';
import STCFormCheckInput from "./STCForm.Check.Input/STCForm.Check.Input";
import STCFormCheckLabel from "./STCForm.Check.Label/STCForm.Check.Label";

function STCFormCheck(props){

    return(
        <Form.Check
            style={props.style}
            className={props.className}
            readOnly={props.readOnly}

            checked={props.checked}
            value={props.value}
            onChange={props.onChange}

            ref={props.ref}
            as={props.as}
            children={props.children}
            disabled={props.disabled}
            feedback={props.feedback}
            id={props.id}
            inline={props.inline}
            isInvalid={props.isInvalid}
            isValid={props.isValid}
            label={props.label}
            reverse={props.reverse}
            title={props.title}
            type={props.type}
            bsPrefix={props.bsPrefix}
            bsSwitchPrefix={props.bsSwitchPrefix}
        >
            {props.children}
        </Form.Check>
    )
}

STCFormCheck.Input = STCFormCheckInput;
STCFormCheck.Label = STCFormCheckLabel;


export default STCFormCheck;